<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc" title="Cover"></h2>
<p id="cover"><img alt="Law and the Bible: Justice, Mercy and Legal Institutions Cover" src="Images/9780830895595.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?48f84e8d